import apiFarms from "../config/api_farms";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiFarms = axios.create({
//   baseURL: "http://localhost:8082",
// });

export function getManufacturersDropdown(payload) {
  const { groupId, farmId, signal } = payload;
  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/manufacturers`,
    getHeaders(false, signal),
  );
}

export function saveManufacturer(payload) {
  const { groupId, farmId, manufacturer, signal } = payload;
  return apiFarms.post(
    `/bovexo/${groupId}/farms/${farmId}/manufacturers`,
    manufacturer,
    getHeaders(false, signal),
  );
}
